import React, { Fragment } from 'react';
import educatorImage from '../images/educators.jpg';
import hem from '../images/hem.jpg';
import ones from '../images/ones.jpg';

const Education = () => {
    return (
        <Fragment>
            <div className="education-container">
                <h1 className="education-title">We Share What Works For Us</h1>
            </div>

            <div className="educator-container">
                <img src={educatorImage} alt="" className="educator-image" />
                <div className="educator-description-container">
                    <h1 className="educator-heading">Habit Education</h1>
                    <p className="education-description">
                        While being in the hair industry for over 20 years we have learned what works for us and
                        what hasn't. Our belief here at Habit when it comes to any type of knowledge we obtain is 
                        sharing. We don't believe we do it the right way we believe how we do things works and if it works 
                        for us it could work for you. So our education is completely designed around sharing what works rather
                        than lecturing or teaching in a traditional way.
                    </p>
                </div>
            </div>

            <div className="available-classes">
                <a target="_blank" rel="noreferrer" href="https://app.habiteducation.com/" className="class-card">
                    <div className="class-card-image-wrap">
                        <img className="hc-class-images" src='https://assets.cdn.filesafe.space/qVWCdNZXHZ5ElwPDlsQG/media/69e66a2e3ea93d9dd2dd9ed3.webp' alt="Habit Education" />
                    </div>
                    <h1 className="education-description-title">Join The Habit Beauty Guild</h1>
                </a>
                <a target="_blank" rel="noreferrer" href="https://habitextensionmethod.com" className="class-card">
                    <div className="class-card-image-wrap">
                        <img className="hc-class-images" src={hem} alt="Habit Extension Method Class Link" />
                    </div>
                    <h1 className="education-description-title">Get Habit Extension Certified</h1>
                </a>
                <a target="_blank" rel="noreferrer" href="https://habitshadow.as.me/oneonone" className="class-card">
                    <div className="class-card-image-wrap">
                        <img className="hc-class-images" src={ones} alt="One On One Class Link" />
                    </div>
                    <h1 className="education-description-title">Receive One on One Training</h1>
                </a>
            </div>
        </Fragment>
    )
};

export default Education;